(function () {
  const wrapper = document.querySelector('[data-price-wrapper]');
  if (!wrapper) return;

  const moneyFormat = window.Shopify?.money_format || '₹{{amount}}';

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    const noDecimals = Math.round(cents / 100).toString();
    return moneyFormat
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', noDecimals)
      .replace('{{amount_with_comma_separator}}', amount)
      .replace('{{amount_no_decimals_with_comma_separator}}', noDecimals);
  }

  function applyDiscount(variantId, originalPrice) {
    const pct = window.__productDiscount__ || 0;

    const priceEl = wrapper.querySelector('[data-auto-discount-price]');
    const compareEl = wrapper.querySelector('[data-auto-discount-compare]');
    const inlineBadge = wrapper.querySelector('[data-auto-discount-badge]');
    const couponBlock = document.getElementById('custom-coupon-block');

    if (!priceEl) return;

    if (pct > 0) {
      const finalPrice = Math.round(originalPrice * (1 - pct / 100));

      wrapper.classList.add('price--on-sale');
      wrapper.classList.add('price--show-badge');
      priceEl.innerHTML = formatMoney(finalPrice);
      if (compareEl) compareEl.innerHTML = formatMoney(originalPrice);
      if (inlineBadge) {
        inlineBadge.textContent = `${pct}% Off`;
        inlineBadge.style.display = 'inline-block';
      }
      if (couponBlock) couponBlock.style.display = 'none';

    } else {
      wrapper.classList.remove('price--on-sale');
      wrapper.classList.remove('price--show-badge');
      priceEl.innerHTML = formatMoney(originalPrice);
      if (compareEl) compareEl.innerHTML = formatMoney(originalPrice);
      if (inlineBadge) inlineBadge.style.display = 'none';
      if (couponBlock) couponBlock.style.display = 'block';
    }
  }

  const variantId = wrapper.dataset.variantId;
  const originalPrice = parseInt(wrapper.dataset.originalPrice);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => applyDiscount(variantId, originalPrice));
  } else {
    applyDiscount(variantId, originalPrice);
  }

  // Update on variant change
  document.addEventListener('variant:changed', (e) => {
    const variant = e.detail?.variant;
    if (!variant) return;
    wrapper.dataset.variantId = variant.id;
    wrapper.dataset.originalPrice = variant.price;
    applyDiscount(variant.id, variant.price);
  });

})();